import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'selec_registro'
})
export class SelecRegistroPipe implements PipeTransform {
  transform(value:any) {
    let items = [];
    for( let item in value ){
      items.push( item );
    }
    return items;
  }
}



// WEBPACK FOOTER //
// C:/xampp/htdocs/service_tracking/web/service_tracking/src/app/pipes/selecRegistro.pipe.ts